export const bidiCharacterRegex: RegExp = /[\u202A-\u202E\u2066-\u2069]/g;
